import { filter, filterOut, map } from './array.no-deps'

export interface Deletable {
    isDeleted: boolean
}

export const isDeleted = <T extends Deletable>(entity: T) => entity.isDeleted
export const isNotDeleted = <T extends Deletable>(entity: T) => !entity.isDeleted

export const filterForDeleted = filter(isDeleted)
export const filterOutDeleted = filterOut(isDeleted)

export const setDeleted = <T>(entity: T) => ({ ...entity, isDeleted: true })
export const setNotDeleted = <T>(entity: T) => ({ ...entity, isDeleted: false })

export const setAllDeleted = map(setDeleted)
export const setAllNotDeleted = map(setNotDeleted)
